import { ePhanGiaoVienActionsObj } from "../../action-types/tkb/IPhanGiaoVienActions";
import { generateActions } from "../generateActions";

export const phanGiaoVienActions = {
  ...generateActions(ePhanGiaoVienActionsObj, "PHAN_GIAO_VIEN"),

};
